/**
 * Frontend-side capability check. Mirrors the backend matrix in deps.py
 * exactly — always verify against the backend for real security, this is
 * strictly UI gating.
 */
export const EMPLOYER_CAPABILITIES = {
    manage_billing:      new Set(["owner"]),
    manage_org_settings: new Set(["owner"]),
    manage_team:         new Set(["owner", "admin"]),
    manage_jobs:         new Set(["owner", "admin", "recruiter"]),
    review_candidates:   new Set(["owner", "admin", "recruiter", "hiring_manager"]),
    message_candidates:  new Set(["owner", "admin", "recruiter"]),
    leave_feedback:      new Set(["owner", "admin", "recruiter", "hiring_manager", "interviewer"]),
    view_candidates:     new Set(["owner", "admin", "recruiter", "hiring_manager", "interviewer"]),
    view_dashboard:      new Set(["owner", "admin", "recruiter", "hiring_manager", "interviewer"]),
};

export function hasCapability(user, capability) {
    if (!user || user.role !== "employer") return false;
    const perm = (user.employer_permission || "").toLowerCase();
    const allowed = EMPLOYER_CAPABILITIES[capability];
    return !!(allowed && allowed.has(perm));
}
